import { render } from "./HomeView.vue?vue&type=template&id=f65b5034"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/empresas/delmondExpress/tecnicos/Tecnicos-Gapal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__